import { Fragment } from 'preact/jsx-runtime';
import type { Product } from '@/domain/Product';
import AccessoryQuickViewDrawer from '../AccessoryQuickViewDrawer/AccessoryQuickViewDrawer.tsx';
import CapsuleQuickViewDrawer from '../CapsuleQuickViewDrawer/CapsuleQuickViewDrawer.tsx';

export type QuickViewDrawerProps = {
  product: Product;
  isOpen: boolean;
  onClose: () => void;
  onGoToProductPage: (e: MouseEvent) => void;
};

export default function QuickViewDrawer({
  product,
  isOpen,
  onClose,
  onGoToProductPage
}: QuickViewDrawerProps) {
  return (
    <Fragment>
      {product.type === 'capsule' && (
        <CapsuleQuickViewDrawer
          product={product}
          isOpen={isOpen}
          onClose={onClose}
          onGoToProductPage={onGoToProductPage}
        />
      )}
      {product.type === 'accessory' && (
        <AccessoryQuickViewDrawer
          product={product}
          isOpen={isOpen}
          onGoToProductPage={onGoToProductPage}
          onClose={onClose}
        />
      )}
    </Fragment>
  );
}
